import store from '@/store';
import { BIZAI_EVENTS } from '@/modules/aiChat/utils/trackingUtils';

export const PAGE_VIEW_EVENT = 'Page View';

export const SESSION_REPLAY_TRIGGER_EVENTS = [
  BIZAI_EVENTS.CHAT_OPENED,
];

/**
 * `Page View` page_name values that start a Session Replay recording (the Web AI
 * Widget pages - see modules/webAIWidget/routes.js meta.pageNameEn).
 */
export const SESSION_REPLAY_TRIGGER_PAGE_NAMES = [
  'Web AI Widget',
  'Web AI Widget Conversation',
  'Website AI Widget Settings',
];

// A recording spans the rest of the session, so it is started once per page
// load; later triggers (another Web AI Widget page, BizAI chat open) are no-ops.
let recordingStarted = false;

const isDirectBusiness = () => !store.getters['BusinessStore/isPartnerDirectory'];

// Matched on event name AND page_name: page_name is also a super property and
// other call sites pass ad-hoc options, so a property-only match over-triggers.
const isTriggerPageView = (eventName, options) => (
  eventName === PAGE_VIEW_EVENT
  && SESSION_REPLAY_TRIGGER_PAGE_NAMES.includes(options?.page_name)
);

const isTriggerEvent = (eventName, options) => (
  SESSION_REPLAY_TRIGGER_EVENTS.includes(eventName)
  || isTriggerPageView(eventName, options)
);

const canStartSessionRecording = (eventName, options) => (
  !recordingStarted
  && isTriggerEvent(eventName, options)
  && isDirectBusiness()
  && typeof window.mixpanel?.start_session_recording === 'function'
);

export const maybeStartSessionRecording = (eventName, options) => {
  if (!canStartSessionRecording(eventName, options)) return;
  recordingStarted = true;
  window.mixpanel.start_session_recording();
};
